import React, { useEffect, useState } from "react";
import styles from "../styles/newsandpress.module.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Col from "react-bootstrap/Col";
import CustomImage from "./CustomImage";
import Link from "next/link";
import format from "date-fns/format";
import Card from "react-bootstrap/Card";
import { formatOrder } from "../utils/constants";
import _debounce from "lodash/debounce";
import fetchUtil from "../utils/fetchUtil";
import Button from "react-bootstrap/Button";
import { isFrappeOrJotFormClass } from "../utils/helpers";
import Head from "next/head";
import { getOnboardingOrFormCtaProps } from "../utils/applyCtaButtonProps";
import { useRouter } from "next/router";
import { persistSourceContext } from "../utils/b2c/sourceTracking";
import { PRIMARY_SOURCE_B2C_WIDGET } from "../utils/b2c/constants";

interface FilterProps {
  searchValue: string;
}

const NewsAndPress: React.FC = (props: any) => {
  const router = useRouter();
  const [blogsdata, setBlogsdata] = useState<any>([]);
  const [blogsCount, setBlogsCount] = useState<number>(0);
  const [filters, setFilters] = useState<FilterProps>({ searchValue: "" });
  const [searchKeyword, setSearchKeyword] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState<any>({});
  const [isViewMore, setIsViewMore] = useState<boolean>(false);
  const { searchValue } = filters;

  const debounceSearchQuery = (searchKeyValue: string) => {
    const search = _debounce(
      () => setFilters({ ...filters, searchValue: searchKeyValue }),
      500,
    );
    setSearchQuery((prevSearch: any) => {
      if (prevSearch.cancel) {
        prevSearch.cancel();
      }
      return search;
    });
    search();
  };

  useEffect(() => {
    const searchCondition = searchValue ? `&title_contains=${searchValue}` : "";
    const limitCondition = isViewMore ? "" : "&_limit=6";
    fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs?_sort=date:DESC&_start=0&stu_dest_categories.category=News${limitCondition}${searchCondition}`,
      "GET",
      {},
      "",
      false,
    ).then((res: any) => {
      setBlogsdata(res);
    });
    fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs/count?_start=0&stu_dest_categories.category=News${searchCondition}${limitCondition}`,
      "GET",
      {},
      "",
      false,
    ).then((res: any) => {
      setBlogsCount(res);
    });
  }, [filters, isViewMore]);

  const applyCtaButtonProps = getOnboardingOrFormCtaProps(router, {
    btnLink: props?.pageData?.bannerBtn?.btnLink,
    formId: props?.pageData?.bannerBtn?.formId,
    toOnboardingEnabled: props?.pageData?.bannerBtn?.toOnboardingEnabled,
  });

  const enquireNowClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (applyCtaButtonProps.mode === "onboarding") {
      persistSourceContext({
        sourceUrl: window.location.href,
        primarySource: PRIMARY_SOURCE_B2C_WIDGET,
        fifthStepVisible: props?.pageData?.bannerBtn?.onBoardingFlow?.nearestOffice ?? true,
        coachingVisible: props?.pageData?.bannerBtn?.onBoardingFlow?.lookingForCoaching ?? true, // CFM-1514
      });
    }
    applyCtaButtonProps.onClick?.(e)
  };

  return (
    <>
      <Head>
        <link
          href="/images/newsandpress/news-bg.svg"
          rel="preload"
          as="image"
          fetchpriority="high"
        />
        <link
          href={blogsdata?.[0]?.newimageUrl?.imageUrl}
          rel="preload"
          as="image"
          fetchpriority="high"
        />
      </Head>
      <div id="news-press" className={styles.newpress}>
        <div className={styles.curve}>
          <div className={styles.content}>
            <Container>
              <Row className="justify-content-center">
                <Col lg={8} md={8} xs={12}>
                  <div className="d-block d-sm-none text-center">
                    <div
                      id="newsand-evenetbreadcrum"
                      className={styles.breadcrum}
                    >
                      <Breadcrumb className={styles.mobileBreadCrum}>
                        <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">
                          Home
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                          News and Press
                        </Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                  </div>
                  <div id="newsnvenet-heading" className={styles.heading}>
                    <div className={styles.breadcrum}>
                      <Breadcrumb className="d-none d-sm-block">
                        <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">
                          Home
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                          News and Press
                        </Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <h1>{props.pageData?.title}</h1>
                    <p>{props.pageData?.description}</p>
                    <Button
                      id="enquirebtn"
                      variant="primary"
                      size="lg"
                      className={`${styles.enquirebtn} btn ${applyCtaButtonProps.formClassName}`}
                      onClick={enquireNowClickHandler}
                    >
                      {props?.pageData?.bannerBtn?.label || "Enquire Now"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <div className={styles.latestNew}>
          <Container>
            <Row>
              <div className={styles.heading}>
                <h2>Latest News</h2>
              </div>
            </Row>
            <div className={styles.news}>
              <div id="filters-drop" className={styles.filtersDrop}>
                <Row>
                  <Col
                    lg={9}
                    md={9}
                    xs={12}
                    className={styles.filtercheck}
                  ></Col>
                  <Col lg={3} md={3} xs={12}>
                    <form className="navbar-form" role="search">
                      <div className="input-group add-on">
                        <div className={styles.inputBox}>
                          <input
                            className="form-control"
                            placeholder="Search News"
                            name="srch-term"
                            id="srch-term"
                            type="text"
                            onChange={(e) => {
                              const searchValues = e.target.value;
                              debounceSearchQuery(searchValues);
                              setSearchKeyword(searchValues);
                            }}
                            value={searchKeyword}
                          />
                          <div className={styles.inputBtn}>
                            <CustomImage
                              src="/searchco.svg"
                              alt="searchco"
                              width={14}
                              height={14}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </Col>
                </Row>
              </div>
              <div id="allLatest-news" className={styles.allnews}>
                <Row>
                  {blogsdata?.length > 0
                    ? blogsdata.map((blog: any, index: number) => {
                        return (
                          <Col xxl={4} xl={4} lg={6} md={6} sm={12} key={index}>
                            <a
                              href={
                                blog.isExternalLink && blog.externalLink
                                  ? blog.externalLink
                                  : `/news/${blog.slug}`
                              }
                            >
                              <Card className={styles.card}>
                                <div className={styles.latestBlogImg}>
                                  <Card.Img
                                    variant="top"
                                    src={blog.newimageUrl.imageUrl}
                                    alt={blog.newimageUrl.alt}
                                    object-fit="fill"
                                  />
                                </div>
                                <Card.Body className={styles.cardBody}>
                                  <h5>{blog.title}</h5>
                                  {blog.shortDescription && (
                                    <p className={styles.shortDescription}>
                                      {blog.shortDescription}
                                    </p>
                                  )}
                                  <div className={styles.bottom}>
                                    <span>
                                      {format(new Date(blog.date), formatOrder)}
                                    </span>
                                    <a
                                      href={
                                        blog.isExternalLink && blog.externalLink
                                          ? blog.externalLink
                                          : `/news/${blog.slug}`
                                      }
                                    >
                                      {" "}
                                      Read More{" "}
                                    </a>
                                  </div>
                                </Card.Body>
                              </Card>
                            </a>
                          </Col>
                        );
                      })
                    : "No News"}
                </Row>
              </div>
              {blogsCount > 6 && !isViewMore && (
                <Row className="text-center">
                  <div
                    id="news-viewmore"
                    onClick={() => setIsViewMore(true)}
                    className={styles.viewMore}
                  >
                    View More
                  </div>
                </Row>
              )}
            </div>
          </Container>
        </div>

        {/* <div className={styles.FeaturedNews}>
          <FeaturedBlogs />
        </div> */}

        <div className={styles.WhyKc}>
          <Container>
            <Row>
              <div className="text-center">
                <h3>Learn more about KC Overseas</h3>
              </div>
            </Row>
            <Row id="learn-moreabt-kc">
              {props?.pageData?.learnMore?.length > 0 &&
                props?.pageData?.learnMore.map((data: any, index: number) => {
                  return (
                    <Col xl={4} md={4} xs={12} key={index}>
                      <div className="text-center mb-3">
                        <div className={styles.img}>
                          <CustomImage
                            src={data.imageUrl}
                            alt={data.alt}
                            width={90}
                            height={90}
                          />
                        </div>
                        <h6>{data.title}</h6>
                        <p>{data.description}</p>
                        <Link href={data.link.href}>
                          <a className={styles.viewMore}>{data.link.label}</a>
                        </Link>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default NewsAndPress;
